import { PageHero, Container, Overline } from "../components/Section";
import { GraduationCap, BookOpen, Users, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const COURSES = [
  { title: "New Believer's Foundations", duration: "6 weeks", level: "Beginner", description: "A guided introduction to the Christian faith — Scripture, prayer, baptism, the church, and the Holy Spirit." },
  { title: "Bible Study Methods", duration: "8 weeks", level: "Intermediate", description: "Learn to read, interpret, and apply Scripture with confidence and care." },
  { title: "Leadership Essentials", duration: "10 weeks", level: "Advanced", description: "Servant leadership shaped by the example of Christ — for ministry leaders and emerging leaders." },
  { title: "Spiritual Disciplines", duration: "4 weeks", level: "All levels", description: "Prayer, fasting, solitude, generosity, worship — practices that form Christlike souls." },
];

export default function ECampus() {
  return (
    <div data-testid="ecampus-page">
      <PageHero
        overline="E-Campus"
        title={<>Grow at <em className="text-gold-light italic font-light">your pace</em>. Online.</>}
        kicker="Online classes, discipleship paths, and Bible studies — accessible wherever you are."
        image="/images/branding/about-church.jpg"
      />

      <Container className="pb-32">
        <div className="grid md:grid-cols-3 gap-px bg-white/5 mb-20">
          {[
            { icon: BookOpen, title: "On-demand Classes", body: "Watch and learn from teachers and pastors anytime, anywhere." },
            { icon: Users, title: "Cohort Discussions", body: "Connect with fellow learners and grow together in community." },
            { icon: GraduationCap, title: "Discipleship Paths", body: "Structured journeys for every season — from new believer to mature disciple." },
          ].map((f) => (
            <div key={f.title} className="bg-wine-950 p-10">
              <f.icon className="h-7 w-7 text-gold mb-5 stroke-[1.5]" />
              <h3 className="font-serif text-xl font-bold mb-3">{f.title}</h3>
              <p className="text-white/65 text-sm leading-relaxed">{f.body}</p>
            </div>
          ))}
        </div>

        <Overline>Featured Courses</Overline>
        <h2 className="font-serif text-4xl md:text-5xl font-black mb-12">Begin your journey.</h2>

        <div className="space-y-px bg-white/5">
          {COURSES.map((c, i) => (
            <div key={c.title} className="bg-wine-950 hover:bg-wine-900 transition-colors p-8 grid md:grid-cols-12 gap-6 items-center" data-testid={`course-${i}`}>
              <div className="md:col-span-1 font-serif italic text-4xl text-gold/40">0{i + 1}</div>
              <div className="md:col-span-7">
                <h3 className="font-serif text-2xl font-bold mb-2">{c.title}</h3>
                <p className="text-white/65 text-sm">{c.description}</p>
              </div>
              <div className="md:col-span-2 text-sm text-white/60"><div>{c.duration}</div><div className="text-xs text-gold/70 uppercase tracking-widest mt-1">{c.level}</div></div>
              <div className="md:col-span-2 text-right">
                <Link to="/register" className="btn-ghost inline-flex items-center gap-2 px-5 py-2 rounded-full text-xs uppercase tracking-widest">Enroll <ArrowRight className="h-3 w-3" /></Link>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
}
